//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date :11/02/2025
// Version : 1
// Description : Creación y edicion de reguladores.
//------Changes --------------------------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Container,
  Typography,
  Grid,
  Box,
  TextField,
  IconButton,
  Button,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { grey } from "@mui/material/colors";
import Notify from "../../Notify";
import Alerta from "../../Alerta";
import { logEventos } from "../../../services/services";

function AddReg(props) {
  const { uuid } = props; // recibir uuid desde props
  const [datosRegulador, setDatosRegulador] = useState({
    id_regulador: null,
    nro_serie: "",
    marca: null,
    modelo: null,
    presion_entrada: null,
    presion_salida: null,
    caudal: null,
    sucursal: null,
    estado: "",
    año_fabricacion: "",
    estado_tab: 324,
    uuid: uuid, // usar el uuid que viene del padre
    usuario: localStorage.getItem("user"),
  });

  const [uso, setUso] = useState(null);
  const [usuarios, setUsuarios] = useState(null);
  const [disBtn, setDisBtn] = useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
  const [finalizar, setFinalizar] = useState(); //finalizar === 1 lo manda como prop el componente "notify" e indica que la transaccion ha finalizado y debe ejecutarse la funcion para cerrar
  const [severityAlerta, setSeverityAlerta] = useState(""); //define severidad de la alerta (success error o warning)
  const [severitySnack, setSeveritySnack] = useState(""); //define severidad del snackbar (notificación)
  const [disabledGuardar, setDisabledGuardar] = useState(false);

  const handleClose = () => {
    props.alta(false);
    props.tabla(true);
  };

  const almacenar = (e) => {
    setDatosRegulador({
      ...datosRegulador,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };
  //*----------------------  OBTENER -----------------------------*//
  const [presionEntrada, setPresionEntrada] = useState([]);
  const [presionEntradaSeleccionada, setPresionEntradaSeleccionada] =
    useState("");

  const obtenerPresionEntrada = () => {
    fetch(UrlApi + "/reguladores_presion_eys")
      .then((data) => data.json())
      .then((data) => setPresionEntrada(data));
  };
  useEffect(() => {
    obtenerPresionEntrada();
  }, []);

  const [presionSalida, setPresionSalida] = useState([]);
  const [presionSalidaSeleccionada, setPresionSalidaSeleccionada] =
    useState("");

  const obtenerPresionSalida = () => {
    fetch(UrlApi + "/reguladores_presion_eys")
      .then((data) => data.json())
      .then((data) => setPresionSalida(data));
  };
  useEffect(() => {
    obtenerPresionSalida();
  }, []);

  const [caudal, setCaudal] = useState([]);
  const [caudalSeleccionado, setCaudalSeleccionado] = useState("");

  const obtenerCaudal = () => {
    fetch(UrlApi + "/reguladores_caudal")
      .then((data) => data.json())
      .then((data) => setCaudal(data));
  };
  useEffect(() => {
    obtenerCaudal();
  }, []);

  const [sucursal, setSucursal] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");

  const obtenerSucursal = () => {
    fetch(UrlApi + "/sucursales")
      .then((data) => data.json())
      .then((data) => setSucursal(data));
  };
  useEffect(() => {
    obtenerSucursal();
  }, []);

  const [estado, setEstado] = useState([]);

  const obtenerEstado = () => {
    fetch(UrlApi + "/desplegables/reguladoresStock")
      .then((data) => data.json())
      .then((data) => setEstado(data));
  };
  useEffect(() => {
    obtenerEstado();
  }, []);

  useEffect(() => {
    if (estado.length > 0) {
      setDatosRegulador((prevState) => ({
        ...prevState,
        estado: estado[0].id, // Asignar el primer valor disponible
      }));
    }
  }, [estado]);

  const [marca, setMarca] = useState([]);
  const [marcaSeleccionada, setMarcaSeleccionada] = useState("");

  const obtenerMarca = () => {
    fetch(UrlApi + "/reguladores_marcas/activos")
      .then((data) => data.json())
      .then((data) => setMarca(data));
  };
  useEffect(() => {
    obtenerMarca();
  }, []);

  const [modelo, setModelo] = useState([]);
  const [modeloSeleccionado, setModeloSeleccionado] = useState("");

  const obtenerModelo = () => {
    fetch(
      UrlApi +
        "/reguladores_marcas/modelosXmarcasActivas/" +
        marcaSeleccionada.id_marca
    )
      .then((data) => data.json())
      .then((data) => setModelo(data));
  };

  useEffect(() => {
    if (marcaSeleccionada) {
      obtenerModelo();
      setModeloSeleccionado(null); // Limpia el modelo seleccionado
    } else {
      setModelo([]); // Si no hay marca seleccionada, limpia los modelos
      setModeloSeleccionado(null);
    }
  }, [marcaSeleccionada]);

  // console.log("MARCA", marca);
  // console.log("MARCA SELEC",marcaSeleccionada);
  // console.log("MODELO",modelo);
  // console.log("MODELO SELEC",modeloSeleccionado);

  //*--------------------------------------------------*//
  const guardarRegulador = async (e) => {
    logEventos(
      "Guardar registro",
      "Administracion Reguladores",
      "Se guardo registro",
      localStorage.getItem("user")
    );
    setDisBtn(true);
    e.preventDefault();
    const response = await fetch(UrlApi + "/reguladores_abm", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nro_serie: datosRegulador.nro_serie,
        marca: marcaSeleccionada.id_marca,
        modelo: modeloSeleccionado.id_modelo,
        presion_entrada: presionEntradaSeleccionada.id_presion,
        presion_salida: presionSalidaSeleccionada.id_presion,
        caudal: caudalSeleccionado.id_caudal,
        sucursal: sucursalSeleccionada.id,
        año_fabricacion: datosRegulador.año_fabricacion,
        estado: datosRegulador.estado,
        estado_tab: 324,
        uuid: uuid,
        usuario: localStorage.getItem("user"),
      }),
    });
    if (response.ok === false) {
      console.log("ERROR EN API");
      const error = response && response.json();
      setError(error);
      setSeverityAlerta("error");
      setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      console.log("Conexión con api OK");
      try {
        //Parseo respuesta de la api a json()
        const json = await response.json();
        //si api me devuelve lo q le puse en message
        if (json.message) {
          //Si ese mensaje es "OK"
          if (json.message === "OK") {
            console.log("Guardado Satisfactoriamente");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("Guardado");
            setSeveritySnack("success");
          } else {
            console.log("res en api incorrecto. Revisar que sea 'OK'");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setSeveritySnack("error");
            setMensaje("Registro Guardado. REVISAR RESPUESTA DE API (E_S)");
          }
        } else if (json.sqlMessage) {
          json && setError(json);
          console.log(json);
          setMensajeAlerta(
            "SQL erróneo (" + json.code + " Errno: " + json.errno + " )"
          );
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          console.log(
            "Guardado. Advertencia: Actualizar respuesta de api. JSON invalido."
          );
          setNotificacion(true);
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("Guardado");
          setSeveritySnack("success");
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      }
    }
    handleClose();
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";

  return (
    <div>
      <Container>
        <Box sx={{ flexGrow: 1, marginTop: 2 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[50] }} />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Registrar Nuevo Regulador
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <form onSubmit={guardarRegulador} autoComplete="off">
          <Box
            backgroundColor="#F4F6F6"
            mt={2}
            p={3}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid
              container
              justifyContent="left"
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={3} mb={1}>
                <TextField
                  fullWidth
                  size={size}
                  margin="normal"
                  placeholder="..."
                  style={style}
                  focused
                  color="primary"
                  required
                  name="nro_serie"
                  label="N° Serie"
                  variant="outlined"
                  value={datosRegulador.nro_serie}
                  inputProps={{
                    maxLength: 60,
                  }}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  size="small"
                  disableClearable
                  id="marca"
                  noOptionsText={"Marca INEXISTENTE"}
                  options={marca}
                  autoHighlight
                  getOptionLabel={(marca) =>
                    marca.id_marca + "-" + marca.descripcion_marca
                  }
                  onChange={(event, value) => setMarcaSeleccionada(value)}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_marca}-{option.descripcion_marca}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      size="small"
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Marca"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  size="small"
                  disableClearable
                  id="id_modelo"
                  noOptionsText={"Modelo INEXISTENTE"}
                  options={modelo}
                  autoHighlight
                  value={modeloSeleccionado} // Controla el valor con el estado
                  getOptionLabel={(modelo) =>
                    modelo
                      ? `${modelo.id_modelo}-${modelo.descripcion_modelos}`
                      : ""
                  }
                  onChange={(event, value) => setModeloSeleccionado(value)}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_modelo}-{option.descripcion_modelos}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      size="small"
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Modelo"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1.5} mb={1}>
                <TextField
                  fullWidth
                  size={size}
                  margin="normal"
                  placeholder="..."
                  style={style}
                  focused
                  color="primary"
                  required
                  name="año_fabricacion"
                  label="Año Fabricación"
                  variant="outlined"
                  value={datosRegulador.año_fabricacion}
                  inputProps={{
                    maxLength: 4,
                  }}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={1.5}>
                <FormControl style={style} focused>
                  <InputLabel>Estado</InputLabel>
                  <Select
                    fullWidth
                    label="Estado"
                    required
                    size="small"
                    name="estado"
                    value={datosRegulador.estado}
                    onChange={almacenar}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    {estado
                      ? estado.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.valor}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  size="small"
                  disableClearable
                  id="presion_entrada"
                  noOptionsText={"Presión de entrada INEXISTENTE"}
                  options={presionEntrada}
                  autoHighlight
                  getOptionLabel={(presionEntrada) =>
                    presionEntrada.id_presion +
                    "-" +
                    presionEntrada.descripcion_presion
                  }
                  onChange={(event, value) =>
                    setPresionEntradaSeleccionada(value)
                  }
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_presion}-{option.descripcion_presion}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      size="small"
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Presión de Entrada"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  size="small"
                  disableClearable
                  id="presion_salida"
                  noOptionsText={"Presión de salida INEXISTENTE"}
                  options={presionSalida}
                  autoHighlight
                  getOptionLabel={(presionSalida) =>
                    presionSalida.id_presion +
                    "-" +
                    presionSalida.descripcion_presion
                  }
                  onChange={(event, value) =>
                    setPresionSalidaSeleccionada(value)
                  }
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_presion}-{option.descripcion_presion}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      size="small"
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Presión de Salida"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  size="small"
                  disableClearable
                  id="caudal"
                  noOptionsText={"Caudal INEXISTENTE"}
                  options={caudal}
                  autoHighlight
                  getOptionLabel={(caudal) =>
                    caudal.id_caudal + "-" + caudal.descripcion_caudal
                  }
                  onChange={(event, value) => setCaudalSeleccionado(value)}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_caudal}-{option.descripcion_caudal}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      size="small"
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Caudal"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  size="small"
                  disableClearable
                  id="sucursal"
                  noOptionsText={"Sucursal INEXISTENTE"}
                  options={sucursal}
                  autoHighlight
                  getOptionLabel={(sucursal) =>
                    sucursal.id + "-" + sucursal.nombre
                  }
                  onChange={(event, value) => setSucursalSeleccionada(value)}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id}-{option.nombre}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      style={style}
                      required
                      focused
                      size="small"
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Sucursal"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                Volver
              </Button>

              <Button
                disabled={disBtn}
                variant="contained"
                type="submit"
                color="success"
              >
                Guardar Regulador
              </Button>
            </Grid>
          </Box>
        </form>
      </Container>
      {notificacion ? (
        <Notify
          mensaje={mensaje}
          open={openSnack}
          color={colormensaje}
          finalizar={setFinalizar}
          severity={severitySnack}
        />
      ) : null}
      {/* ALERT --> SE MUESTRA SI HAY UN ERROR EN LA API (NO SE CONECTA O ESTÁ MAL LA RUTA, ETC.) */}
      {error && mensajeAlerta ? (
        <Alerta mensaje={mensajeAlerta} severity={severityAlerta} />
      ) : null}
    </div>
  );
}

export default AddReg;
